// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2wBD_","col":"styles_col__1tY4U","fulfillmentStatus":"styles_fulfillmentStatus__qneiD","emailCol":"styles_emailCol__1zNJB"};